/**CORE LIBRARIES IMPORT */
import React from "react";



const HealthWellness=()=>{
    return(
        <>

        </>
    )
}

export default HealthWellness;